<template>
  <div class="note-folder-detail">
    <div class="note-folder-detail__menu-container">
      <div class="note-folder-detail__menu">
        <v-icon @click="goBack" v-if="showBack">mdi-arrow-left-top</v-icon>
        <v-icon @click="addNote" class="btn-icon">mdi-note-plus</v-icon>
        <v-icon @click="showAddFolderModal = true" class="btn-icon">mdi-folder-plus</v-icon>
        <v-icon @click="deleteFolder" color="red" class="btn-icon" v-if="showDeleteFolder">mdi-delete</v-icon>
      </div>
    </div>
    <div class="note-folder-detail__menu-form" v-if="showAddFolderModal">
      <v-text-field 
          v-model="newFolderName" 
          label="Nome" 
          required 
          density="compact"
          hide-details
      >
        
      </v-text-field>
      <div class="icon-btn-group">
        <v-icon @click="createFolder" class="icon-btn">mdi-content-save</v-icon>
        <v-icon @click="showAddFolderModal=false">mdi-arrow-u-left-bottom</v-icon>
      </div>
    </div>
    <div class="card-deck">
      <v-card class="card" v-for="folder in noteFolder.folders" :key="folder.id">
        <router-link :to="`/notebook/${notebookId}/folder/${encodeURIComponent(folder.path)}/${folder.id}`">
          <v-img src="/img/folder.svg" :alt="folder.name" height="150px"></v-img>
          <div class="card-description">
            <v-card-title itemprop="headline">{{ folder.name }}</v-card-title>
          </div>
        </router-link>
      </v-card>
      <v-card class="card" v-for="note in noteFolder.notes" :key="note.id">
        <router-link :to="`/notebook/${notebookId}/note/${encodeURIComponent(folderPath)}/${note.id}`" >
          <v-img src="/img/description.svg" :alt="note.title" height="150px"></v-img>
          <div class="card-description">
            <v-card-title itemprop="headline">{{ note.title }}</v-card-title>
          </div>
        </router-link>
      </v-card>
    </div>
  </div>
</template>

<script>
import NoteFolder from "@/entities/NoteFolder";
import apiService from "@/services/ApiService";

export default {
  name: 'NoteFolder',
  props: {
    noteFolder: {
      type: NoteFolder,
      required: true
    },
    notebookId: {
      type: String,
      required: true
    },
    showDeleteFolder: {
      type: Boolean,
      default: false
    },
    showBack: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showAddFolderModal: false,
      newFolderName: ''
    }
  },
  computed: {
    folderPath() {
      return this.noteFolder.id === this.notebookId
          ? `/`
          : this.noteFolder.path === '/'
              ? `/${this.noteFolder.id}`
              : `${this.noteFolder.path}/${this.noteFolder.id}`;
    },
    parentPath() {
      const pathParts = this.noteFolder.path
          .split('/')
          .filter(x => !!x);

      if (pathParts.length === 0 || pathParts.length === 1)
        return  '/';

      return '/' + pathParts.slice(0, -1).join('/');
    },
    parentFolderId() {
      const pathParts = this.noteFolder.path
          .split('/')
          .filter(x => !!x);

      if (pathParts.length === 0)
        return this.notebookId;

      return pathParts.pop();
    }
  },
  methods: {
    addNote() {
      this.$router.push(`/notebook/${this.notebookId}/note/${encodeURIComponent(this.folderPath)}/`);
    },
    goBack() {
      if(this.parentFolderId === this.notebookId) {
        this.$router.push(`/notebook/${this.notebookId}/`);
      } else {
        this.$router.push(`/notebook/${this.notebookId}/folder/${encodeURIComponent(this.parentPath)}/${this.parentFolderId}`);
      }
    },
    async createFolder() {
      if (this.newFolderName.trim() === '') {
        return;
      }
      const path = this.folderPath;
      const newFolder = {
        name: this.newFolderName,
        path: path,
        userId: '',
        createdAt: new Date(),
        updatedAt: new Date(),
        notes: [],
        folders: []
      };
      try {
        this.$store.dispatch('setLoading', true);
        await apiService.createInnerFolder(this.notebookId, path, newFolder);
        this.$emit('folderCreated', newFolder);
        this.showAddFolderModal = false;
        this.newFolderName = '';
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.dispatch('setLoading', false);
      }
    },
    async deleteFolder() {
      const confirmation = confirm(`Sei sicuro di voler eliminare la cartella ${this.noteFolder.name}?`);
      if (!confirmation) {
        return;
      }
      try {
        this.$store.dispatch('setLoading', true);
        await apiService.deleteInnerFolder(this.notebookId, this.noteFolder.path, this.noteFolder.id);

        this.$emit('folderDeleted');
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.dispatch('setLoading', false);
      }
      //await this.$store.dispatch('updateSelectedMainFolder', this.notebookId);
    }
  }
}
</script>

<style scoped lang="scss">
@import '../style/_variables.scss';
.note-folder-detail {
  width: 100%;
  padding-left: 5px;
  .note-folder-detail__menu-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 5px;
    .note-folder-detail__menu{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      height: auto;
      justify-content: center;
      align-items: center;
      border: 1px solid $primary-color;
      background: var(--secondary-background-color);
      border-radius: 5px;
      color: $primary-contrast-color;
      padding: 10px;
    }
  }
  .note-folder-detail__menu-form {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
    align-items: center;
    padding: 5px;
    background: var(--background-color);
    color: $primary-contrast-color;
    .v-text-field {
      max-width: 250px;
    }
  }
}

.btn-icon {
  font-size: 2rem;
  margin: 0 5px;
}
</style>